// A follow-up link is valid only while the exact fixture can still be opened.
export function isAvailableLockedPick(data, fixtureId, now = Date.now()) {
  const raw = data?.raw;
  const kickoff = raw?.fixture?.timestamp
    ? Number(raw.fixture.timestamp) * 1000
    : Date.parse(raw?.fixture?.date);
  return Number(raw?.fixture?.id) === fixtureId
    && Number.isFinite(kickoff)
    && kickoff > now
    && Boolean(data?.prediction);
}

export function hasPaidAnalyticsAccess(user) {
  const tier = (user?.subscription_tier || 'free').toLowerCase();
  const status = (user?.subscription_status || '').toLowerCase();
  return (tier === 'basic' || tier === 'premium') && status === 'active';
}

export function hasMatchAnalyticsAccess(user, unlocks, fixtureId) {
  const id = Number(fixtureId);
  return hasPaidAnalyticsAccess(user) || (
    Number.isSafeInteger(id) && id > 0
    && unlocks?.success === true
    && Array.isArray(unlocks.match_ids)
    && unlocks.match_ids.some(unlockedId => Number(unlockedId) === id)
  );
}